import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  Input,
  OnChanges,
  SimpleChanges,
  OnInit,
} from '@angular/core';
import { PhxKpiChangeType, PhxKpiChangeTypeEnum } from './phx-overview.types';
import { ArrowUp, ArrowDown, CircleExclamation } from '../icon/icon-map';
import { calculateChange } from './phx-overview.utils';

@Component({
  selector: 'phx-overview-prefix',
  styleUrls: ['./phx-overview-prefix.component.scss'],
  templateUrl: './phx-overview-prefix.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'phx-overview-prefix',
    '[class.phx-overview-prefix-error]': 'phxHasError',
    '[class.phx-overview-prefix-disabled]': 'phxDisabled',
    '[attr.tabindex]': '-1',
    '[attr.disabled]': 'phxDisabled',
    '[attr.aria-disabled]': 'phxDisabled',
  },
})
export class PhxOverviewPrefixComponent implements OnInit, OnChanges {
  /**
   * The label text for the prefix
   */
  @Input() public phxLabel: string | null = null;

  /**
   * The current numeric value
   */
  @Input() public phxValue: number = 0;

  /**
   * The previous numeric value for comparison
   */
  @Input() public phxPreviousValue: number | null = null;

  /**
   * Optional subtext to display below the value
   */
  @Input() public phxSubtext: string | null = null;

  /**
   * To disable the prefix item
   */
  @Input() public phxDisabled: boolean = false;

  /**
   * To show error state (red color) for the prefix item
   */
  @Input() public phxHasError: boolean = false;

  /**
   * Error message to display when in error state.
   */
  @Input() public phxErrorMessage: string = 'data could not be calculated.';

  public changeValue: number = 0;
  public absoluteChangeValue: number = 0;
  public changeType: PhxKpiChangeType = PhxKpiChangeTypeEnum.NoChange;
  public arrowIcon: string;

  public readonly ArrowUp: string = ArrowUp;
  public readonly ArrowDown: string = ArrowDown;
  public readonly CircleExclamation: string = CircleExclamation;
  public readonly arrowSize: number = 12;

  public ngOnInit(): void {
    this.setupValues();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    const { phxValue, phxPreviousValue } = changes;
    if (phxValue || phxPreviousValue) {
      this.setupValues();
    }
  }

  public getChangeContainerClass(): string {
    return `phx-overview-prefix-${this.changeType}`;
  }

  private setupValues(): void {
    const hasPreviousValue = !!this.phxPreviousValue;
    const hasValue = !!this.phxValue;
    if (!hasPreviousValue || !hasValue) {
      this.changeType = PhxKpiChangeTypeEnum.NoChange;
      return;
    }

    const { changeValue, absoluteChangeValue, changeType } = calculateChange(this.phxValue, this.phxPreviousValue);
    this.changeValue = changeValue;
    this.absoluteChangeValue = absoluteChangeValue;
    this.changeType = changeType;
    this.arrowIcon = changeValue > 0 ? this.ArrowUp : this.ArrowDown;
  }
}
